import { AssistantActionRef, AssistantExecuteResult } from '../../types/ai.types';

export type AssistantProgress = 'open' | 'run' | 'done' | 'error';

export function immediateActionPath(action: AssistantActionRef): string | null {
  if (action.id === 'run_search') return '/orders?search=true&expert=1';
  if (action.id === 'create_order') return '/orders?create=true';
  if (action.id === 'create_automation' || action.id === 'create_product' || action.id === 'create_status' || action.id === 'create_chart' || action.id === 'create_client' || action.id === 'create_commission_rule' || action.id === 'adjust_stock' || action.id === 'pin_search') {
    return null;
  }
  if (action.id === 'apply_chart') return '/dashboard';
  if (action.id === 'apply_saved_search') return '/orders?search=true';
  if (action.type === 'open' && action.path && action.path.startsWith('/')) {
    return action.path;
  }
  return null;
}

export function confirmLabel(): string {
  return 'Confirmer';
}

export function progressLabel(step: AssistantProgress, label: string): string {
  if (step === 'open') return `J’ouvre · ${label}`;
  if (step === 'run') return `Je génère · ${label}`;
  if (step === 'error') return 'Échec';
  return `Fait · ${label}`;
}

export function resultFacts(payload: AssistantExecuteResult | null | undefined): string[] {
  const raw = payload?.result;
  if (!raw || typeof raw !== 'object') return [];
  const facts = raw.facts;
  if (!Array.isArray(facts)) return [];
  return facts.map((item) => String(item || '').trim()).filter(Boolean).slice(0, 6);
}

export function resultTitle(payload: AssistantExecuteResult | null | undefined, fallback: string): string {
  const raw = payload?.result;
  const title = raw && typeof raw === 'object' ? String(raw.title || '').trim() : '';
  return title || fallback;
}

export function toastForResult(actionId: string, title: string): string {
  if (actionId === 'run_search') return title || 'Filtres appliqués';
  if (actionId === 'save_search') return title || 'Recherche enregistrée';
  if (actionId === 'create_order') return 'Formulaire commande';
  if (actionId === 'create_automation') return title || 'Automatisation créée';
  if (actionId === 'apply_saved_search') return title || 'Recherche ouverte';
  if (actionId === 'create_product') return title || 'Produit créé';
  if (actionId === 'create_status') return title || 'Statut créé';
  if (actionId === 'create_chart') return title || 'Graphique créé';
  if (actionId === 'apply_chart') return title || 'Graphique ouvert';
  if (actionId === 'pin_search') return title || 'Recherche épinglée';
  if (actionId === 'create_client') return title || 'Client créé';
  if (actionId === 'create_commission_rule') return title || 'Règle créée';
  if (actionId === 'adjust_stock') return title || 'Stock ajusté';
  return title;
}
